// @flow

import React from 'react'
import styled from 'styled-components'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import { mediaMax } from 'frontend_core/dist/styles/media'

export const SiteFooterBottom = styled.div`
  background-color: #2a2a2a;
  color: #fff;
  line-height: 1.5;
  padding: 32px 0;
  ${mediaMax.tablet`
    padding: 20px 0 10px;
  `};
`
export const Links = styled.div`
  float: left;
  width: 80%;
  ${mediaMax.tablet`
    width: 100%;
  `};
`
export const ComList = styled.ul`
  display: block;
  padding: 0 0 10px;
  ${mediaMax.tablet`
    text-align: center;
    padding-top: 12px;
  `};
`
export const ComListItem = styled.li`
  display: inline-block;
  padding: 0 16px 0 0;
`
export const ComLink = styled.a`
  color: #fff;
  font-size: 12px;

  &:visited {
    color: #fff;
  }

  &:hover {
    color: #ccc;
  }

  ${mediaMax.tablet`
    display: block;
    padding: 8px;
  `};
`
export const SnsList = styled.ul`
  display: block;
  position: relative;
  ${mediaMax.tablet`
    text-align: center;
  `};
`
export const SnsListItem = styled.li`
  display: inline-block;
  padding: 0 16px 0 0;
  ${mediaMax.tablet`
    padding: 0 8px;
  `};
`
export const Sns = styled.a`
  color: #fff;
  font-size: 24px;

  &:hover {
    color: #ccc;
    text-decoration: none;
  }

  &:visited {
    color: #fff;
  }
`
export const Copyrights = styled.div`
  display: block;
  color: #c9c9c9;
  ${mediaMax.tablet`
    text-align: center;
    margin-bottom: 8px;
  `};
`
export const CopyrightsSmall = styled.small`
  display: block;
  padding-top: 10px;
  color: #c9c9c9;
`

export default () => (
  <SiteFooterBottom>
    <div className="container">
      <Links>
        <ComList>
          <ComListItem>
            <ComLink href="http://spacemarket.co.jp">運営会社</ComLink>
          </ComListItem>
          <ComListItem>
            <ComLink href="http://spacemarket.co.jp/recruit">採用情報</ComLink>
          </ComListItem>
          <ComListItem>
            <ComLink href={wwwUrl('/about/agreement')}>約款</ComLink>
          </ComListItem>
          <ComListItem>
            <ComLink href={wwwUrl('/about/tokushoho')}>
              特定商取引法に基づく表示
            </ComLink>
          </ComListItem>
        </ComList>
        <SnsList>
          <SnsListItem>
            <Sns href="https://www.facebook.com/spacemarketjp" target="">
              <i className="fab fa-facebook-square" />
            </Sns>
          </SnsListItem>
          <SnsListItem>
            <Sns href="https://twitter.com/spacemarketjp" target="">
              <i className="fab fa-twitter-square" />
            </Sns>
          </SnsListItem>
          <SnsListItem>
            <Sns href="https://www.instagram.com/spacemarketjp/" target="">
              <i className="fab fa-instagram" />
            </Sns>
          </SnsListItem>
        </SnsList>
        <Copyrights>
          <CopyrightsSmall>
            <img
              src={imagePath('service/footer/logo_spmkt.png')}
              height="12"
              width="113"
              alt="SPACEMARKET"
            />{' '}
            &copy; Spacemarket, Inc.{' '}
          </CopyrightsSmall>
        </Copyrights>
      </Links>
      <div className="site-footer__language_menu">
        <span className="site-footer__select">
          <i className="fas fa-caret-down site-footer__select__icon" />
          <div id="google_translate_element" />
          <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              // eslint-disable-line
              __html: `
                function googleTranslateElementInit() {
                  new google.translate.TranslateElement({pageLanguage: 'ja', includedLanguages: 'en,ja', autoDisplay: false, gaTrack: true, gaId: 'UA-46693491-17'}, 'google_translate_element');
                }
              `,
            }}
          />
          <script
            type="text/javascript"
            src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
            async
          />
        </span>
      </div>
    </div>
  </SiteFooterBottom>
)
